import React from 'react';
import MealsStyle from './Meals.module.css';

import AvailableMeals from './AvailableMeals';
import MealsSummary from './MealsSummary';

function Meals() {
  return (
    <div className={MealsStyle.container}>
        <MealsSummary />
        <AvailableMeals />
    </div>
  )
}

export default Meals;